import { pdf } from "@react-pdf/renderer";
import InvoicePDF from "../Page/Orders/InvoicePDF";

export const downloadInvoice = async (
  order
) => {
  const blob = await pdf(
    <InvoicePDF order={order} />
  ).toBlob();

  const url =
    window.URL.createObjectURL(blob);

  const a =
    document.createElement("a");

  a.href = url;

  a.download = `Invoice-${order.orderDisplayId}.pdf`;

  document.body.appendChild(a);

  a.click();

  document.body.removeChild(a);

  window.URL.revokeObjectURL(url);
};